// extracted by mini-css-extract-plugin
export default {"padding":"Webinar_padding__LkJuv","JCC":"Webinar_JCC__hIjoE","flex":"Webinar_flex__jz42+"};